import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { Grid } from "../../components/grid/Grid";
import {
  Avatar,
  Box,
  Button,
  Divider,
  InputBase,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
} from "@mui/material";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import PeopleIcon from "@mui/icons-material/People";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { LOG_OUT } from "../../lib/redux/slices/userSlice";
import {
  BACKDROP_HIDE,
  CLOSE_MODAL,
  DRAWER,
  OPEN_MODAL,
  SET_SEARCH_MARKER,
} from "../../lib/redux/slices/appSlice";
import user from "../../assets/images/user.png";
import CheckIcon from "@mui/icons-material/Check";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import CloseIcon from "@mui/icons-material/Close";
import { getFaProvince } from "../../utils/getFaProvince";
import {
  ROUTE_DASHBOARD,
  ROUTE_STATICS,
  ROUTE_USERS,
  ROUTE_USER_INSPECTIONS,
} from "../../routes/routes";
import { useLocation, useNavigate } from "react-router-dom";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import { motion } from "framer-motion";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { MainAddFilter } from "../../features/main/components/main-add-filter/MainAddFilter";
import { styled, alpha } from "@mui/material/styles";
import iranView from "../../assets/images/IranOutlined.png";
import { SPACING } from "../../data/spacing";
import { LocationOn } from "@mui/icons-material";

export const Header = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.userSlice.loginUserProfile);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [avatarAnchorEl, setAvatarAnchorEl] = React.useState(null);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const avatarOpen = Boolean(avatarAnchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAvatarClick = (event) => {
    setAvatarAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAvatarAnchorEl(null);
  };

  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  }));

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    width: "100%",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create("width"),
      [theme.breakpoints.up("sm")]: {
        width: "0ch",
        "&:focus": {
          width: "20ch",
        },
      },
    },
  }));

  return (
    <AppBar
      position={pathname === ROUTE_DASHBOARD ? "fixed" : "relative"}
      style={{
        backgroundColor: "primary",
        height: "50px",
        justifyContent: "center",
      }}
    >
      <Toolbar>
        <div>
          <Grid display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundImage: `url(${iranView})`,
                backgroundSize: "contain",
                backgroundRepeat: "repeat",
                backgroundPosition: "center",
                opacity: 0.05,
                zIndex: 0,
                pointerEvents: "none",
              }}
            />
            <Button
              style={{ color: " white" }}
              endIcon={<FilterAltIcon />}
              onClick={() => {
                dispatch(
                  DRAWER({
                    title: "فیلتر نقشه",
                    content: <MainAddFilter />,
                    left: !(window.innerWidth <= 600),
                    bottom: window.innerWidth <= 600,
                  })
                );
              }}
            >
              فیلتر
            </Button>

            <Grid sx={{ cursor: "pointer" }}>
              <Avatar alt="Remy Sharp" src={user} onClick={handleAvatarClick} />
            </Grid>
            <Popover
              open={avatarOpen}
              anchorEl={avatarAnchorEl}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              PaperProps={{
                style: {
                  borderRadius: "12px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                  minWidth: "250px",
                },
              }}
            >
              <Box p={2}>
                <Box display="flex" alignItems="center" mb={2}>
                  <Avatar sx={{ width: 56, height: 56, mr: 2 }}>
                    {profile?.fullname?.charAt(0)}
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold">
                      {profile?.fullname}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {profile?.mobile}
                    </Typography>
                  </Box>
                </Box>

                <Divider />

                <List>
                  <ListItem>
                    <ListItemIcon>
                      <LocationOn />
                    </ListItemIcon>
                    <ListItemText
                      primary={"استان " + getFaProvince(profile?.province)}
                      secondary={
                        profile?.permissions?.includes("admin")
                          ? "ادمین کل"
                          : "بازرس"
                      }
                    />
                  </ListItem>
                </List>
              </Box>
            </Popover>
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="جستجو + اینتر"
                inputProps={{ "aria-label": "search" }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    dispatch(SET_SEARCH_MARKER(e.target.value));
                  }
                }}
              />
            </Search>
          </Grid>
        </div>

        <Grid
          sx={{ userSelect: "none", flexGrow: 1 }}
          variant="h6"
          component="div"
          justifyContent="center"
          alignItems="center"
        >
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
          >
            <Typography
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/");
              }}
              variant="body1"
              display={{
                lg: "contents",
                md: "contents",
                sm: "contents",
                xs: "none",
              }}
            >
              سامانه بازرسی و نظارت اصناف رصدیار
            </Typography>
          </motion.div>
        </Grid>

        <Grid display="flex" alignItems="center" gap={SPACING.SMALL}>
          <Button
            sx={{ color: "white" }}
            alignItems="center"
            mt={SPACING.SMALL}
            startIcon={<SettingsApplicationsIcon />}
            id="demo-positioned-button"
            aria-controls={open ? "demo-positioned-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            اقدام
          </Button>

          <Popover
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            {profile.permissions?.includes("add") && (
              <MenuItem
                onClick={() => {
                  navigate(ROUTE_USERS);
                }}
              >
                <ListItemIcon>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="کاربران" />
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                navigate(ROUTE_USER_INSPECTIONS);
              }}
            >
              <ListItemIcon>
                <SearchIcon />
              </ListItemIcon>
              <ListItemText primary="سوابق بازرسی من" />
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate(ROUTE_STATICS);
              }}
            >
              <ListItemIcon>
                <SignalCellularAltIcon />
              </ListItemIcon>
              <ListItemText primary="آمار" />
            </MenuItem>
            <a
              style={{ textDecoration: "none", color: "inherit" }}
              href="https://ravandno.storage.iran.liara.space/Inspection_4_1.0.apk"
            >
              <MenuItem>
                <ListItemIcon>
                  <PhoneAndroidIcon />
                </ListItemIcon>
                <ListItemText primary="دانلود برنامه اندروید" />
              </MenuItem>
            </a>
            <MenuItem
              onClick={() => {
                dispatch(
                  DRAWER({ right: false, bottom: false, content: null })
                );
                dispatch(
                  OPEN_MODAL({
                    title: "از سامانه خارج میشوید؟",
                    modalColor: "#d0f9f9",
                    content: (
                      <Grid container gap={SPACING.SMALL}>
                        <Button
                          endIcon={<CheckIcon />}
                          color="error"
                          variant="contained"
                          onClick={() => {
                            dispatch(BACKDROP_HIDE());
                            dispatch(CLOSE_MODAL());
                            dispatch(LOG_OUT());
                          }}
                        >
                          بله
                        </Button>
                        <Button
                          endIcon={<CloseIcon />}
                          variant="outlined"
                          onClick={() => {
                            dispatch(CLOSE_MODAL());
                          }}
                        >
                          خیر
                        </Button>
                      </Grid>
                    ),
                  })
                );
              }}
            >
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="خروج از سامانه" />
            </MenuItem>
          </Popover>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};
